import { ValueGetterParams } from 'ag-grid-community';
import {
    DetailedEnvelopeMantyStatusHypothesis,
    EnvelopeMantyStatusHypothesis,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/helpers/types';
import {
    ORG_CHART_HR_SOFTWARE_ID,
    MANTY_STATUS,
} from 'routes/HumanResourcesModule/business/definitions';

export const envelopeMantyStatusHypothesisValueGetter =
    (
        envelopeMantyStatusHypotheses:
            | EnvelopeMantyStatusHypothesis[]
            | DetailedEnvelopeMantyStatusHypothesis[],
    ) =>
    (params: ValueGetterParams) => {
        const { data } = params;
        if (!data) return undefined;
        const hypothesis = envelopeMantyStatusHypotheses.find(
            (hyp) =>
                hyp[ORG_CHART_HR_SOFTWARE_ID] ===
                    data[ORG_CHART_HR_SOFTWARE_ID] &&
                hyp[MANTY_STATUS] === data[MANTY_STATUS],
        );
        return hypothesis;
    };
